import React, { FC, useRef, useEffect, useState, memo, useMemo } from 'react';
import * as eCharts from 'echarts';
import { lineTooltipFormatter } from '../Retention/linechart';
import { useIntl, getLocale } from 'umi';

interface DigitalLineChartProps {
  lineSeries: any[];
  lineXAxis: any[];
}

const GaasLineChart: FC<DigitalLineChartProps> = (props) => {
  let myChart: any = null;
  const { lineSeries, lineXAxis } = props;
  const chartRef = useRef(null);
  const [options, setOptions] = useState<any>();
  const { formatMessage } = useIntl();
  const locale = getLocale();
  const lineXAxisList = useMemo(()=> {
    return lineXAxis?.map((item, index)=> `${formatMessage({id: 'dbi_benchmark_year'},{ num: index+1})} `)
  }, [locale, lineXAxis])
  
  useEffect(() => {
    const gameLineOptions = {
      title: {
        show: false,
        text: '',
        textStyle: {
          fontSize: 14,
        },
      },
      color: ['#5086F3', '#5EC8F1'],
      tooltip: {
        backgroundColor: 'rgba(255, 255, 255, 0)',
        extraCssText: 'border: none;',
        padding: 0,
        trigger: 'axis',
        axisPointer: {
          z: 0,
          label: {
            show: true,
            color: '#3B3D4B',
            backgroundColor: '#FFF',
          },
          lineStyle: {
            color: '#BBBDCB',
            type: 'solid'
          }  
        },
        formatter: (param: any[]) => {
          return lineTooltipFormatter(
            param?.sort((a, b) => b?.value - a?.value),
            param[0]?.axisValue,
            '',
            (value: any) => `${value}%`,
          );
        },
        // confine: true,
        // showDelay: 10,
        // hideDelay: 100,
        className: 'topcharts-line-tooltip',
      },
      legend: {
        selectedMode: true,
        itemWidth: 8,
        itemHeight: 8,
        itemGap: 18,
        width: '100%',
        bottom: -4,
        icon: 'circle',
        left: 'center',
        textStyle: {
          color: '#888888',
          fontSize: 12,
        },
      },
      grid: {
        left: '0px',
        right: 0,
        bottom: '24px',
        containLabel: true,
        top: 10,
      },
      xAxis: [
        {
          type: 'category',
          boundaryGap: true,
          data: lineXAxisList,
          axisTick: {
            alignWithLabel: true,
            lineStyle: {
              color: '#BFBFBF',
              width: 1,
            },
          },
          axisLabel: {
            color: '#000',
            align: 'center',
            opacity: 0.45,
            fontSize: 12,
            margin: 10,
          },
          axisLine: {
            show: true,
            onZero: false,
            lineStyle: {
              color: '#BFBFBF',
              width: 1,
            },
          },
        },
      ],
      yAxis: [
        {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
            },
          },
          splitNumber: 4,
          axisLabel: {
            formatter: '{value}%',
            color: '#000',
            opacity: 0.45,
            fontSize: 12,
          },
          minInterval: 1,
        },
      ],
      series: lineSeries?.map(item=> ({...item, name: formatMessage({id: `dbi_${item?.name?.toLowerCase()}`})})),
    };

    setOptions(gameLineOptions);
  }, [lineSeries, locale]);

  const handleResize = () => {
    try {
      myChart.resize();
    } catch (err) {}
  };

  useEffect(() => {
    if (myChart === null) {
      myChart = eCharts.init(chartRef!.current!);
    }
    options && myChart.setOption(options);
  }, [options]);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [myChart]);

  return <div ref={chartRef} style={{ height: 264, width: '100%' }}></div>;
};

GaasLineChart.defaultProps = {};

export default memo(GaasLineChart);
